<template>

<main class="py-12 space-y-12">
        <section>
            <div class="container">
                <article class="space-y-8">
                    <h1
                        v-if="route.query?.status === '5'"
                    >
                        Newsletter-Abmeldung
                    </h1>
                    <h1
                        v-else
                    >
                        Newsletter-Anmeldung
                    </h1>

                    <div v-if="route.query?.status === '1'">
                        <h2>Vielen Dank</h2>
                        <p>Sie sind nun erfolgreich beim Newsletter von Sauerland Spielgeräte GmbH angemeldet!</p>
                    </div>

                    <h3 v-else-if="route.query?.status === '4'">
                        Ihre E-Mail-Adresse befindet sich bereits im Newsletter-Verteiler!
                    </h3>

                    <h3 v-else-if="route.query?.status === '5'">
                        Ihre E-Mail-Adresse wurde erfolgreich aus dem Newsletter-Verteiler entfernt!
                    </h3>

                    <h3 v-else-if="route.query?.status === '8'">
                        Die eingegebene E-Mail-Adresse befindet sich nicht in unserem Newsletter-Verteiler!
                    </h3>

                    <form
                        v-else-if="mailSent === false && route.query?.status !== '2' && route.query?.status !== '4'"
                        class="contact-form space-y-4 py-4 text-xs lg:space-y-8 lg:py-0 lg:text-base"
                        method="post"
                        @submit.prevent="checkPrivacy"
                    >
                        <UFormField
                            label="E-Mail"
                            required
                        >
                            <UInput
                                id="email"
                                v-model="email"
                                type="email"
                                name="email"
                                class="w-full"
                            />
                            <div
                                v-if="errorEmail"
                                class="text-primary text-xs"
                            >
                                Bitte geben Sie Ihre E-Mail-Adresse ein!
                            </div>
                        </UFormField>

                        <UCheckbox
                            v-model="privacy"
                            size="xl"
                            variant="list"
                            required
                            style="padding-inline: 0 !important; padding-block: 0 !important;"
                        >
                            <template #label>
                                Mit dem Absenden Ihrer Daten willigen Sie ein, dass wir Ihnen den Newsletter an Ihre
                                angegebene E-Mail-Adresse senden und das Nutzerverhalten auswerten dürfen. Details zur
                                Verarbeitung Ihrer personenbezogenen Daten erhalten Sie in unseren <a
                                href="/Datenschutz/"
                                target="_blank"
                            >Datenschutzhinweisen</a>. Mit Absenden Ihrer Anmeldung bestätigen Sie, dass Sie unsere
                                Datenschutzhinweise zur Kenntnis genommen haben. Eine Abmeldung ist jederzeit über den
                                in jedem Newsletter zur Verfügung gestellten Link möglich.
                            </template>
                        </UCheckbox>
                        <div
                            v-if="errorPrivacy"
                            class="text-primary text-xs"
                        >
                            Sie müssen bestätigen, dass Sie die Datenschutzhinweise zur Kenntnis genommen haben!
                        </div>

                        <div class="requiredNotice">
                            * Pflichtfelder
                        </div>
                      <UButton
                          label="Anmelden"
                          type="submit"
                      />
                    </form>

                    <h3 v-if="mailSent">
                        Wir haben Ihnen soeben eine E-Mail zugesendet, in der Sie bitte Ihre Newsletter-Anmeldung bestätigen müssen!
                    </h3>

                    <form
                        v-else-if="route.query?.status === '2'"
                        ref="formRef"
                        method="post"
                        action="https://008.frnl.de/box.php"
                    >
                        <input
                            id="p"
                            name="p"
                            type="hidden"
                            value="2127"
                        >
                        <input
                            name="funcml"
                            type="hidden"
                            value="add"
                        >
                        <input
                            type="hidden"
                            name="nlbox[1]"
                            :value="config.public.newsletterGroupId"
                        >
                        <input
                            id="email"
                            name="email"
                            type="hidden"
                            :value="route.query.email"
                        >
                        <h3>Bitte warten...</h3>
                    </form>
                </article>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Newsletter-Anmeldung',
});

const route = useRoute();
const config = useRuntimeConfig();

const {public: pub} = useRuntimeConfig();
const toast = useToast();

const email = ref('');
const privacy = ref(false);
const errorEmail = ref(false);
const errorPrivacy = ref(false);
const submitting = ref(false);

const formRef = ref(null);

const mailSent = ref(false);

async function sendMessage() {
    const response = await $fetch<{ sent: boolean }>(`${pub.apiUrl}/api/newsletter`, {
        method: 'POST',
        body: {
            email: email.value,
        },
    });

    if (response.sent) {
        toast.add({
            title: 'Erfolgreich versendet',
            description: 'Ihre Nachricht wurde erfolgreich versendet. Bitte prüfen Sie Ihre E-Mail-Nachrichten!',
            color: 'success',
        });
    }

    mailSent.value = true;
}

async function checkPrivacy(e) {
    if (submitting.value) return;
    submitting.value = true;

    if (email.value === '') {
        errorEmail.value = true;
        return;
    }
    errorEmail.value = false;

    if (!privacy.value) {
        errorPrivacy.value = true;
        return;
    }
    errorPrivacy.value = false;
    await sendMessage();
}

onMounted(() => {
    if (route.query?.status === '2' && formRef.value) {
        formRef.value.submit();
    } else if (route.query?.status === '4') {
        email.value = route.query.email;
        toast.add({
            title: 'Erfolgreiche Abfrage',
            description: 'Ihre E-Mail-Adresse befindet sich bereits im Newsletter-Verteiler!',
            color: 'success',
        });
    }
});
</script>

<style scoped>

</style>
